import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import RestService from './RestService';
import logger from 'js-logger';

var GeneralConfigService = function () {
  function GeneralConfigService() {
    _classCallCheck(this, GeneralConfigService);
  }

  _createClass(GeneralConfigService, null, [{
    key: 'init',

    // flags:
    value: function init() {
      this.rest = GeneralConfigService.initRestService();
    }
  }, {
    key: 'initRestService',
    value: function initRestService() {
      return new RestService();
    }

    /* FEATURE TOGGLES */

  }, {
    key: 'loadFeatureToggle',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.rest.getFeatureToggle(key);

              case 3:
                response = _context.sent;

                this.featureToggles[key] = response.data[key];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                if (typeof _context.t0.response !== 'undefined') {
                  logger.error(_context.t0.response.data);
                } else {
                  logger.error(_context.t0);
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function loadFeatureToggle(_x) {
        return _ref.apply(this, arguments);
      }

      return loadFeatureToggle;
    }()
  }, {
    key: 'getFeatureToggle',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.featureToggles[key]) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.loadFeatureToggle(key);

              case 3:
                return _context2.abrupt('return', this.featureToggles[key]);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getFeatureToggle(_x2) {
        return _ref2.apply(this, arguments);
      }

      return getFeatureToggle;
    }()
  }, {
    key: 'ensureEnabledProductLinesLoaded',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.enabledProductLines.length) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.getEnabledProductLines();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ensureEnabledProductLinesLoaded() {
        return _ref3.apply(this, arguments);
      }

      return ensureEnabledProductLinesLoaded;
    }()
  }, {
    key: 'ensureEnabledSubbranchesLoaded',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.enabledSubbranches.length) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.getEnabledSubbranches();

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ensureEnabledSubbranchesLoaded() {
        return _ref4.apply(this, arguments);
      }

      return ensureEnabledSubbranchesLoaded;
    }()
  }, {
    key: 'ensureEnabledContextItemsLoaded',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.enabledContextItems.length) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return this.getEnabledContextItems();

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function ensureEnabledContextItemsLoaded() {
        return _ref5.apply(this, arguments);
      }

      return ensureEnabledContextItemsLoaded;
    }()
  }, {
    key: 'ensureEnabledFunctionItemsLoaded',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.enabledFunctionItems.length) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return this.getEnabledFunctionItems();

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function ensureEnabledFunctionItemsLoaded() {
        return _ref6.apply(this, arguments);
      }

      return ensureEnabledFunctionItemsLoaded;
    }()
  }, {
    key: 'ensureEnabledValueMappingLoaded',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.enabledValueMapping.length) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return this.getEnabledValueMapping();

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function ensureEnabledValueMappingLoaded() {
        return _ref7.apply(this, arguments);
      }

      return ensureEnabledValueMappingLoaded;
    }()
  }, {
    key: 'sortProductLinesByDescription',
    value: function sortProductLinesByDescription(productLines) {
      return productLines.sort(function (a, b) {
        return a.description.localeCompare(b.description);
      });
    }
  }, {
    key: 'sortContextItemsByDescription',
    value: function sortContextItemsByDescription(contextItems) {
      return contextItems.sort(function (a, b) {
        return a.description.localeCompare(b.description);
      });
    }
  }, {
    key: 'sortFunctionItemsByDescription',
    value: function sortFunctionItemsByDescription(functionItems) {
      return functionItems.sort(function (a, b) {
        return a.description.localeCompare(b.description);
      });
    }
  }, {
    key: 'sortValueMappingByDescription',
    value: function sortValueMappingByDescription(valueMapping) {
      return valueMapping.sort(function (a, b) {
        return a.description.localeCompare(b.description);
      });
    }
  }, {
    key: 'getAllProductLines',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.allProductLines.length) {
                  _context8.next = 11;
                  break;
                }

                _context8.prev = 1;
                _context8.next = 4;
                return this.rest.getAllProductLines();

              case 4:
                response = _context8.sent;

                this.allProductLines = this.sortProductLinesByDescription(response.data);
                _context8.next = 11;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8['catch'](1);

                if (typeof _context8.t0.response !== 'undefined') {
                  logger.error(_context8.t0.response.data);
                } else {
                  logger.error(_context8.t0);
                }

              case 11:
                return _context8.abrupt('return', this.allProductLines);

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 8]]);
      }));

      function getAllProductLines() {
        return _ref8.apply(this, arguments);
      }

      return getAllProductLines;
    }()
  }, {
    key: 'getAllSubbranches',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.allSubbranches.length) {
                  _context9.next = 11;
                  break;
                }

                _context9.prev = 1;
                _context9.next = 4;
                return this.rest.getAllSubbranches();

              case 4:
                response = _context9.sent;

                this.allSubbranches = this.sortProductLinesByDescription(response.data);
                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9['catch'](1);

                if (typeof _context9.t0.response !== 'undefined') {
                  logger.error(_context9.t0.response.data);
                } else {
                  logger.error(_context9.t0);
                }

              case 11:
                return _context9.abrupt('return', this.allSubbranches);

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 8]]);
      }));

      function getAllSubbranches() {
        return _ref9.apply(this, arguments);
      }

      return getAllSubbranches;
    }()
  }, {
    key: 'getAllContextItems',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (this.allContextItems.length) {
                  _context10.next = 11;
                  break;
                }

                _context10.prev = 1;
                _context10.next = 4;
                return this.rest.getAllContextItems();

              case 4:
                response = _context10.sent;

                this.allContextItems = this.sortContextItemsByDescription(response.data);
                _context10.next = 11;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10['catch'](1);

                if (typeof _context10.t0.response !== 'undefined') {
                  logger.error(_context10.t0.response.data);
                } else {
                  logger.error(_context10.t0);
                }

              case 11:
                return _context10.abrupt('return', this.allContextItems);

              case 12:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[1, 8]]);
      }));

      function getAllContextItems() {
        return _ref10.apply(this, arguments);
      }

      return getAllContextItems;
    }()
  }, {
    key: 'getAllFunctionItems',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (this.allFunctionItems.length) {
                  _context11.next = 11;
                  break;
                }

                _context11.prev = 1;
                _context11.next = 4;
                return this.rest.getAllFunctionItems();

              case 4:
                response = _context11.sent;

                this.allFunctionItems = this.sortFunctionItemsByDescription(response.data);
                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11['catch'](1);

                if (typeof _context11.t0.response !== 'undefined') {
                  logger.error(_context11.t0.response.data);
                } else {
                  logger.error(_context11.t0);
                }

              case 11:
                return _context11.abrupt('return', this.allFunctionItems);

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 8]]);
      }));

      function getAllFunctionItems() {
        return _ref11.apply(this, arguments);
      }

      return getAllFunctionItems;
    }()
  }, {
    key: 'getAllValueMapping',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (this.allValueMapping.length) {
                  _context12.next = 11;
                  break;
                }

                _context12.prev = 1;
                _context12.next = 4;
                return this.rest.getAllValueMapping();

              case 4:
                response = _context12.sent;

                this.allValueMapping = this.sortValueMappingByDescription(response.data);
                _context12.next = 11;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12['catch'](1);

                if (typeof _context12.t0.response !== 'undefined') {
                  logger.error(_context12.t0.response.data);
                } else {
                  logger.error(_context12.t0);
                }

              case 11:
                return _context12.abrupt('return', this.allValueMapping);

              case 12:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[1, 8]]);
      }));

      function getAllValueMapping() {
        return _ref12.apply(this, arguments);
      }

      return getAllValueMapping;
    }()

    /* ENABLED PRODUCTLINES */

  }, {
    key: 'getEnabledProductLines',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (this.enabledProductLines.length) {
                  _context13.next = 5;
                  break;
                }

                _context13.next = 3;
                return this.getAllProductLines();

              case 3:
                _context13.t0 = function (productline) {
                  return productline.enabled === true;
                };

                this.enabledProductLines = _context13.sent.filter(_context13.t0);

              case 5:
                return _context13.abrupt('return', this.enabledProductLines);

              case 6:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getEnabledProductLines() {
        return _ref13.apply(this, arguments);
      }

      return getEnabledProductLines;
    }()
  }, {
    key: 'getEnabledSubbranches',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (this.enabledSubbranches.length) {
                  _context14.next = 5;
                  break;
                }

                _context14.next = 3;
                return this.getAllSubbranches();

              case 3:
                _context14.t0 = function (subbranch) {
                  return subbranch.enabled === true;
                };

                this.enabledSubbranches = _context14.sent.filter(_context14.t0);

              case 5:
                return _context14.abrupt('return', this.enabledSubbranches);

              case 6:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getEnabledSubbranches() {
        return _ref14.apply(this, arguments);
      }

      return getEnabledSubbranches;
    }()
  }, {
    key: 'getEnabledContextItems',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.enabledContextItems.length) {
                  _context15.next = 5;
                  break;
                }

                _context15.next = 3;
                return this.getAllContextItems();

              case 3:
                _context15.t0 = function (contextitems) {
                  return contextitems.enabled === true;
                };

                this.enabledContextItems = _context15.sent.filter(_context15.t0);

              case 5:
                return _context15.abrupt('return', this.enabledContextItems);

              case 6:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getEnabledContextItems() {
        return _ref15.apply(this, arguments);
      }

      return getEnabledContextItems;
    }()
  }, {
    key: 'getEnabledFunctionItems',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (this.enabledFunctionItems.length) {
                  _context16.next = 5;
                  break;
                }

                _context16.next = 3;
                return this.getAllFunctionItems();

              case 3:
                _context16.t0 = function (functionitems) {
                  return functionitems.enabled === true;
                };

                this.enabledFunctionItems = _context16.sent.filter(_context16.t0);

              case 5:
                return _context16.abrupt('return', this.enabledFunctionItems);

              case 6:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getEnabledFunctionItems() {
        return _ref16.apply(this, arguments);
      }

      return getEnabledFunctionItems;
    }()
  }, {
    key: 'getEnabledValueMapping',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.enabledValueMapping.length) {
                  _context17.next = 5;
                  break;
                }

                _context17.next = 3;
                return this.getAllValueMapping();

              case 3:
                _context17.t0 = function (valuemapping) {
                  return valuemapping.enabled === true;
                };

                this.enabledValueMapping = _context17.sent.filter(_context17.t0);

              case 5:
                return _context17.abrupt('return', this.enabledValueMapping);

              case 6:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getEnabledValueMapping() {
        return _ref17.apply(this, arguments);
      }

      return getEnabledValueMapping;
    }()
  }, {
    key: 'addOrUpdateEnabledProductLine',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(productLine) {
        var updatedProductIndex;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.ensureEnabledProductLinesLoaded();

              case 2:
                updatedProductIndex = this.enabledProductLines.findIndex(function (product) {
                  return product.id === productLine.id;
                });

                if (updatedProductIndex !== -1) {
                  this.enabledProductLines[updatedProductIndex] = productLine;
                } else {
                  this.enabledProductLines.push(productLine);
                }
                this.enabledProductLines = this.sortProductLinesByDescription(this.enabledProductLines);

              case 5:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function addOrUpdateEnabledProductLine(_x3) {
        return _ref18.apply(this, arguments);
      }

      return addOrUpdateEnabledProductLine;
    }()
  }, {
    key: 'addOrUpdateEnabledSubbranche',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(subbranche) {
        var updatedProductIndex;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.ensureEnabledSubbranchesLoaded();

              case 2:
                updatedProductIndex = this.enabledSubbranches.findIndex(function (product) {
                  return product.id === subbranche.id;
                });

                if (updatedProductIndex !== -1) {
                  this.enabledSubbranches[updatedProductIndex] = subbranche;
                } else {
                  this.enabledSubbranches.push(subbranche);
                }
                this.enabledSubbranches = this.sortProductLinesByDescription(this.enabledProductLines);

              case 5:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function addOrUpdateEnabledSubbranche(_x4) {
        return _ref19.apply(this, arguments);
      }

      return addOrUpdateEnabledSubbranche;
    }()
  }, {
    key: 'addOrUpdateEnabledContextItems',
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(contextItems) {
        var updatedProductIndex;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.ensureEnabledContextItemsLoaded();

              case 2:
                updatedProductIndex = this.enabledContextItems.findIndex(function (product) {
                  return product.id === contextItems.id;
                });

                if (updatedProductIndex !== -1) {
                  this.enabledContextItems[updatedProductIndex] = contextItems;
                } else {
                  this.enabledContextItems.push(contextItems);
                }
                this.enabledContextItems = this.sortProductLinesByDescription(this.enabledContextItems);

              case 5:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function addOrUpdateEnabledContextItems(_x5) {
        return _ref20.apply(this, arguments);
      }

      return addOrUpdateEnabledContextItems;
    }()
  }, {
    key: 'addOrUpdateEnabledFunctionItems',
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(functionItems) {
        var updatedProductIndex;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.ensureEnabledFunctionItemsLoaded();

              case 2:
                updatedProductIndex = this.enabledFunctionItems.findIndex(function (product) {
                  return product.id === functionItems.id;
                });

                if (updatedProductIndex !== -1) {
                  this.enabledFunctionItems[updatedProductIndex] = functionItems;
                } else {
                  this.enabledFunctionItems.push(functionItems);
                }
                this.enabledFunctionItems = this.sortProductLinesByDescription(this.enabledFunctionItems);

              case 5:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function addOrUpdateEnabledFunctionItems(_x6) {
        return _ref21.apply(this, arguments);
      }

      return addOrUpdateEnabledFunctionItems;
    }()
  }, {
    key: 'addOrUpdateEnabledValueMapping',
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(valueMapping) {
        var updatedProductIndex;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.ensureEnabledValueMappingLoaded();

              case 2:
                updatedProductIndex = this.enabledValueMapping.findIndex(function (product) {
                  return product.id === valueMapping.id;
                });

                if (updatedProductIndex !== -1) {
                  this.enabledValueMapping[updatedProductIndex] = valueMapping;
                } else {
                  this.enabledValueMapping.push(valueMapping);
                }
                this.enabledValueMapping = this.sortProductLinesByDescription(this.enabledValueMapping);

              case 5:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function addOrUpdateEnabledValueMapping(_x7) {
        return _ref22.apply(this, arguments);
      }

      return addOrUpdateEnabledValueMapping;
    }()
  }, {
    key: 'removeEnabledProductLine',
    value: function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(productLine) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.ensureEnabledProductLinesLoaded();

              case 2:
                this.enabledProductLines = this.enabledProductLines.filter(function (epl) {
                  return epl.name !== productLine.name;
                });

              case 3:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function removeEnabledProductLine(_x8) {
        return _ref23.apply(this, arguments);
      }

      return removeEnabledProductLine;
    }()
  }, {
    key: 'removeEnabledSubbranche',
    value: function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(subbranche) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.ensureEnabledSubbranchesLoaded();

              case 2:
                this.enabledSubbranches = this.enabledSubbranches.filter(function (epl) {
                  return epl.name !== subbranche.name;
                });

              case 3:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function removeEnabledSubbranche(_x9) {
        return _ref24.apply(this, arguments);
      }

      return removeEnabledSubbranche;
    }()
  }, {
    key: 'removeEnabledContextItems',
    value: function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(contextItems) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.ensureEnabledContextItemsLoaded();

              case 2:
                this.enabledContextItems = this.enabledContextItems.filter(function (epl) {
                  return epl.name !== contextItems.name;
                });

              case 3:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function removeEnabledContextItems(_x10) {
        return _ref25.apply(this, arguments);
      }

      return removeEnabledContextItems;
    }()
  }, {
    key: 'removeEnabledFunctionItems',
    value: function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(functionItems) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.ensureEnabledFunctionItemsLoaded();

              case 2:
                this.enabledFunctionItems = this.enabledFunctionItems.filter(function (epl) {
                  return epl.name !== functionItems.name;
                });

              case 3:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function removeEnabledFunctionItems(_x11) {
        return _ref26.apply(this, arguments);
      }

      return removeEnabledFunctionItems;
    }()
  }, {
    key: 'removeEnabledValueMapping',
    value: function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(valueMapping) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.ensureEnabledValueMappingLoaded();

              case 2:
                this.enabledValueMapping = this.enabledValueMapping.filter(function (epl) {
                  return epl.name !== valueMapping.name;
                });

              case 3:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function removeEnabledValueMapping(_x12) {
        return _ref27.apply(this, arguments);
      }

      return removeEnabledValueMapping;
    }()

    /* POLICYCASE STATUSES */

  }, {
    key: 'loadPolicyCaseStatuses',
    value: function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var response;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;
                _context28.next = 3;
                return this.rest.getPolicyCaseStatuses();

              case 3:
                response = _context28.sent;

                this.policyCaseStatuses = response.data;
                _context28.next = 10;
                break;

              case 7:
                _context28.prev = 7;
                _context28.t0 = _context28['catch'](0);

                if (typeof _context28.t0.response !== 'undefined') {
                  logger.error(_context28.t0.response.data);
                } else {
                  logger.error(_context28.t0);
                }

              case 10:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this, [[0, 7]]);
      }));

      function loadPolicyCaseStatuses() {
        return _ref28.apply(this, arguments);
      }

      return loadPolicyCaseStatuses;
    }()
  }, {
    key: 'getPolicyCaseStatuses',
    value: function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (this.policyCaseStatuses) {
                  _context29.next = 3;
                  break;
                }

                _context29.next = 3;
                return this.loadPolicyCaseStatuses();

              case 3:
                return _context29.abrupt('return', this.policyCaseStatuses);

              case 4:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function getPolicyCaseStatuses() {
        return _ref29.apply(this, arguments);
      }

      return getPolicyCaseStatuses;
    }()

    /* POLICYCASE BATCH IDS */

  }, {
    key: 'loadPolicyCaseBatchIds',
    value: function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var response;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                _context30.next = 3;
                return this.rest.getAvailableDistinctBatchIds();

              case 3:
                response = _context30.sent;

                this.policyCaseBatchIds = response.data;
                _context30.next = 10;
                break;

              case 7:
                _context30.prev = 7;
                _context30.t0 = _context30['catch'](0);

                if (typeof _context30.t0.response !== 'undefined') {
                  logger.error(_context30.t0.response.data);
                } else {
                  logger.error(_context30.t0);
                }

              case 10:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this, [[0, 7]]);
      }));

      function loadPolicyCaseBatchIds() {
        return _ref30.apply(this, arguments);
      }

      return loadPolicyCaseBatchIds;
    }()
  }, {
    key: 'getPolicyCaseBatchIds',
    value: function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (!(!this.policyCaseBatchIds || this.forceUpdatePolicyCaseBatchIds)) {
                  _context31.next = 4;
                  break;
                }

                _context31.next = 3;
                return this.loadPolicyCaseBatchIds();

              case 3:
                this.forceUpdatePolicyCaseBatchIds = false;

              case 4:
                return _context31.abrupt('return', this.policyCaseBatchIds);

              case 5:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function getPolicyCaseBatchIds() {
        return _ref31.apply(this, arguments);
      }

      return getPolicyCaseBatchIds;
    }()

    /* CUSTOMER BATCH IDS */

  }, {
    key: 'loadCustomerBatchIds',
    value: function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        var response;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                _context32.next = 3;
                return this.rest.getCustomerDistinctBatchIds();

              case 3:
                response = _context32.sent;

                this.customerBatchIds = response.data;
                _context32.next = 10;
                break;

              case 7:
                _context32.prev = 7;
                _context32.t0 = _context32['catch'](0);

                if (typeof _context32.t0.response !== 'undefined') {
                  logger.error(_context32.t0.response.data);
                } else {
                  logger.error(_context32.t0);
                }

              case 10:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, this, [[0, 7]]);
      }));

      function loadCustomerBatchIds() {
        return _ref32.apply(this, arguments);
      }

      return loadCustomerBatchIds;
    }()
  }, {
    key: 'getCustomerBatchIds',
    value: function () {
      var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (!(!this.customerBatchIds || this.forceUpdateCustomerBatchIds)) {
                  _context33.next = 4;
                  break;
                }

                _context33.next = 3;
                return this.loadCustomerBatchIds();

              case 3:
                this.forceUpdateCustomerBatchIds = false;

              case 4:
                return _context33.abrupt('return', this.customerBatchIds);

              case 5:
              case 'end':
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function getCustomerBatchIds() {
        return _ref33.apply(this, arguments);
      }

      return getCustomerBatchIds;
    }()

    /* MY USER NAME */

  }, {
    key: 'loadMyUserName',
    value: function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        var response;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.prev = 0;
                _context34.next = 3;
                return this.rest.getMyUserName();

              case 3:
                response = _context34.sent;

                this.myUserName = response.data;
                _context34.next = 10;
                break;

              case 7:
                _context34.prev = 7;
                _context34.t0 = _context34['catch'](0);

                if (typeof _context34.t0.response !== 'undefined') {
                  logger.error(_context34.t0.response.data);
                } else {
                  logger.error(_context34.t0);
                }

              case 10:
              case 'end':
                return _context34.stop();
            }
          }
        }, _callee34, this, [[0, 7]]);
      }));

      function loadMyUserName() {
        return _ref34.apply(this, arguments);
      }

      return loadMyUserName;
    }()
  }, {
    key: 'getMyUserName',
    value: function () {
      var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                if (this.myUserName) {
                  _context35.next = 3;
                  break;
                }

                _context35.next = 3;
                return this.loadMyUserName();

              case 3:
                return _context35.abrupt('return', this.myUserName);

              case 4:
              case 'end':
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function getMyUserName() {
        return _ref35.apply(this, arguments);
      }

      return getMyUserName;
    }()
  }, {
    key: 'getAllProductRows',
    value: function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        var response;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                if (this.productRows) {
                  _context36.next = 5;
                  break;
                }

                _context36.next = 3;
                return this.rest.getAllProductRows();

              case 3:
                response = _context36.sent;

                this.productRows = response.data;

              case 5:
                return _context36.abrupt('return', this.productRows);

              case 6:
              case 'end':
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function getAllProductRows() {
        return _ref36.apply(this, arguments);
      }

      return getAllProductRows;
    }()
  }, {
    key: 'getAllInsurerRows',
    value: function () {
      var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        var response;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if (this.insurerRows) {
                  _context37.next = 5;
                  break;
                }

                _context37.next = 3;
                return this.rest.getAllInsurerRows();

              case 3:
                response = _context37.sent;

                this.insurerRows = response.data;

              case 5:
                return _context37.abrupt('return', this.insurerRows);

              case 6:
              case 'end':
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function getAllInsurerRows() {
        return _ref37.apply(this, arguments);
      }

      return getAllInsurerRows;
    }()
  }, {
    key: 'getAllProducts',
    value: function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var response;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.prev = 0;
                _context38.next = 3;
                return this.rest.getAllProductRows();

              case 3:
                response = _context38.sent;

                this.allProducts = response.data;
                _context38.next = 10;
                break;

              case 7:
                _context38.prev = 7;
                _context38.t0 = _context38['catch'](0);

                if (typeof _context38.t0.response !== 'undefined') {
                  logger.error(_context38.t0.response.data);
                } else {
                  logger.error(_context38.t0);
                }

              case 10:
                return _context38.abrupt('return', this.allProducts);

              case 11:
              case 'end':
                return _context38.stop();
            }
          }
        }, _callee38, this, [[0, 7]]);
      }));

      function getAllProducts() {
        return _ref38.apply(this, arguments);
      }

      return getAllProducts;
    }()

    /* ENABLED PRODUCTS */

  }, {
    key: 'getEnabledProducts',
    value: function () {
      var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.getAllProducts();

              case 2:
                _context39.t0 = function (productline) {
                  return productline.enabled === true;
                };

                this.enabledProducts = _context39.sent.filter(_context39.t0);
                return _context39.abrupt('return', this.enabledProducts);

              case 5:
              case 'end':
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function getEnabledProducts() {
        return _ref39.apply(this, arguments);
      }

      return getEnabledProducts;
    }()
  }]);

  return GeneralConfigService;
}();

GeneralConfigService.featureToggles = {};
GeneralConfigService.allProductLines = [];
GeneralConfigService.allSubbranches = [];
GeneralConfigService.allContextItems = [];
GeneralConfigService.allFunctionItems = [];
GeneralConfigService.enabledProductLines = [];
GeneralConfigService.enabledSubbranches = [];
GeneralConfigService.enabledContextItems = [];
GeneralConfigService.enabledFunctionItems = [];
GeneralConfigService.allProducts = [];
GeneralConfigService.enabledProducts = [];
GeneralConfigService.forceUpdatePolicyCaseBatchIds = false;
GeneralConfigService.forceUpdateCustomerBatchIds = false;
export default GeneralConfigService;


// WEBPACK FOOTER //
// ./src/service/GeneralConfigService.js